
namespace Matrix.Workflow {

    @Serenity.Decorators.registerEditor("Matrix.Workflow.WorkflowInstanceTaskInstanceGrid")
    export class WorkflowInstanceTaskInstanceGrid extends SiteEntityGrid<TaskInstanceRow, any> {
        protected getColumnsKey() { return 'Workflow.TaskInstance'; }
        protected getDialogType() { return TaskInstanceDialog; }
        protected getIdProperty() { return TaskInstanceRow.idProperty; }
        protected getLocalTextPrefix() { return TaskInstanceRow.localTextPrefix; }
        protected getService() { return TaskInstanceService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getInitialTitle() {
            return null;
        }

        protected usePager() {
            return false;
        }

        private _workflowInstanceId: number;

        get workflowInstanceId() {
            return this._workflowInstanceId;
        }

        set workflowInstanceId(value: number) {
            if (this._workflowInstanceId !== value) {
                this._workflowInstanceId = value;
                this.setEquality(WorkflowInstanceRow.Fields.WorkflowInstanceId, value);
                this.refresh();
            }
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this._workflowInstanceId;
        }

        protected getColumns() {
            return super.getColumns().filter(x => x.field != TaskInstanceRow.Fields.WorkflowInstanceId &&
                x.field != TaskInstanceRow.Fields.WorkflowCode);
        }

    }
}